<template>
    <div class="loader"></div>
</template>

<script>
export default {
    name: "AppLoader"
}
</script>

<style scoped>

</style>